import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import aquaculture from "../../../assets/images/aquaculture.jpg";
import innovation from "../../../assets/images/innovation.jpg";
import stock from "../../../assets/images/stock.jpg";

const newsDetails = [
  {
    title: "Boosting Nigeria’s Economy Through Aquaculture Investment",
    subtitle:
      "Aquaculture offers an untapped economic potential for Nigeria, particularly given the high demand for fish and seafood in a country where over 60% of animal protein comes from fish.",
    date: "July 29, 2024",
    author: "Edna Dionisio",
    pics: aquaculture,
    links:
      "/2024-07-29/boosting-Nigerias-economy-through-aquaculture-investment",
  },
  {
    title: " Digital Innovations in Fish Farming",
    subtitle:
      "In a world increasingly driven by technology, the aquaculture industry in Nigeria is ripe for digital transformation. With a vast and growing aquaculture sector, Nigeria stands to benefit greatly from digital tools that can improve...",
    date: "May 4, 2024",
    author: "Olalekan Adeleke",
    pics: innovation,
    links: "/2024-05-04/digital-innovations-in-fish-farming",
  },
  {
    title: "Fishery Stock Assessments and Sustainable Management in Nigeria",
    subtitle:
      "Fishery stock assessments are critical for understanding the health and sustainability of fish populations in Nigeria’s waters. These assessments evaluate fish population sizes,...",
    date: "August 15, 2023",
    author: "Prof. Yemi Akegbejo-Samsons",
    pics: stock,
    links:
      "/2023-08-15/fishery-stock-assessments-and-sustainable-management-in-Nigeria",
  },
];

const Blog = () => {
  return (
    <Grid container padding={{ xs: "2% 0% 20% 0%", sm: "2% 0% 10% 0%" }}>
      <Box
        width={{ xs: "100%", sm: "40%" }}
        marginLeft={{ xs: "0%", sm: "0%" }}
      >
        <Typography
          variant={"h3"}
          fontWeight={900}
          textAlign={"left"}
          color={"#00AEEF"}
          paddingBottom={"1%"}
        >
          <Typography
            component={"span"}
            variant={"h3"}
            color="#3E4095"
            fontWeight={900}
          >
            Our {""}
          </Typography>
          Blog
        </Typography>
      </Box>
      <Grid
        item
        xs={12}
        md={12}
        display={"flex"}
        justifyContent={"space-between"}
        flexWrap={"wrap"}
      >
        {newsDetails.map((details, index) => {
          const { pics, title, subtitle, date, author, links } = details;
          return (
            <Grid
              item
              key={index}
              xs={12}
              md={4}
              marginTop={{ xs: "10%", sm: "3%" }}
            >
              <Card sx={{ maxWidth: 380 }}>
                <CardActionArea href={links}>
                  <CardMedia
                    component="img"
                    height={"250vh"}
                    image={pics}
                    alt="blog_img"
                  />
                  <CardContent>
                    <Typography
                      fontWeight={500}
                      variant="body2"
                      color={"#aaa"}
                      paddingBottom={"4%"}
                    >
                      {date}
                    </Typography>
                    <Typography
                      gutterBottom
                      fontWeight={900}
                      variant="h5"
                      component="div"
                      paddingBottom={"2%"}
                      color="#194ec3"
                    >
                      {title}
                    </Typography>
                    <Typography
                      gutterBottom
                      fontWeight={400}
                      variant="body1"
                      component="div"
                      paddingBottom={"4%"}
                      color="#4f4f4f"
                    >
                      {subtitle}
                    </Typography>
                    <Typography
                      fontWeight={500}
                      variant="body2"
                      color={"#00AEEF"}
                    >
                      {author}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default Blog;
